<script lang="ts">
    import { z } from 'zod';
    import * as echarts from 'echarts';
    import { _ } from 'svelte-i18n';

    import { type StatusApiDataRequestType } from '../../../../shared/Dashboard/WidgetOneApi';
    import WidgetTemplateInner from '../../../../shared/Dashboard/WidgetTemplateInner.svelte';
    import {
        type DashboardComponentType,
        WidgetManager,
    } from '../../../../shared/Dashboard/WidgetManager';
    import { DataSchema, type DataType } from './types';

    export let dashboardItem: DashboardComponentType;
    export let widgetManager: WidgetManager;

    const colors = ['#91CC75', '#f4ce59', '#d93b4d'];
    const defaultChartOption: echarts.EChartsOption = {
        color: colors,
        tooltip: {
            trigger: 'item',
        },
        grid: {
            containLabel: true,
            left: '10%',
            right: '10%',
            top: '10%',
            bottom: '10%',
        },
        series: [
            {
                type: 'pie',
                radius: ['30%', '60%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 5,
                    borderColor: '#fff',
                    borderWidth: 2,
                },
                label: {
                    show: true,
                    position: 'outside', // Display labels outside the pie chart
                    formatter: '{c}', // Display name, value, and percentage
                    fontSize: 14,
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 12,
                        fontWeight: 'bold',
                    },
                },
                labelLine: {
                    show: true,
                    length: 10, // Length of the line connecting the label to the chart
                    length2: 10, // Length of the second segment of the line
                    smooth: false, // Makes the line smooth and curved
                },
                data: [
                    { value: 0, name: $_('Completed') },
                    { value: 0, name: $_('exceeded') },
                    { value: 0, name: $_('not_completed') },
                ],
            },
        ],
    };

    dashboardItem.we.setChartOption(defaultChartOption);
    dashboardItem.we.setDataSchema(DataSchema);
    dashboardItem.we.setUpdateFunction((defaultChartOption, data: DataType) => {
        return {
            ...defaultChartOption,
            series: [
                {
                    ...defaultChartOption?.series[0],
                    data: data,
                },
            ],
        };
    });
</script>

<WidgetTemplateInner bind:widgetManager {dashboardItem} />
